import template from './commondrgchanges.html';
import controller from './commondrgchanges.controller';
import './commondrgchanges.styl';

let commondrgchangesComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default commondrgchangesComponent;



// WEBPACK FOOTER //
// ./client/app/common/reports/commondrgchanges/commondrgchanges.component.js